module.exports = __webpack_public_path__ + "img/code.8b2ab89e.png";